module.exports = __webpack_public_path__ + "static/media/RX Plus+-en.9f30a147.jpg";